<!DOCTYPE html>
<html lang="fr">

<head>
	<meta charset="UTF-8">
	<meta name="viewport" content="width=device-width, initial-scale=1.0">
	<title>Ivann Machado | Grid Menu</title>
	<meta name="description" content="Portfolio menu in-game base for Ivann Machado.">
	<link rel="icon" href="data:,">
	<link rel="preconnect" href="https://fonts.googleapis.com">
	<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
	<link
		href="https://fonts.googleapis.com/css2?family=Advent+Pro:wght@400;500;600;700&family=Oxanium:wght@400;500;600;700&display=swap"
		rel="stylesheet">
	<script type="module" src="/assets/ts/init/index.ts"></script>
	<style>
		.hidden {
			display: none !important;
		}
	</style>
</head>

<body style="background-color: #000;">
	<div id="screen">
		<div id="screen-bg">
			<header class="hud-bar">
				<div class="hud-bar__frame" data-augmented-ui="t-clip-x both">
					<span>Neural Portfolio Interface</span>
				</div>
			</header>


			<div id="main">
				<div id="wrap3d" class="wrap3d">
					<div class="left-trim"></div>
					<div class="right-trim"></div>
					<div class="bottom-trim"></div>
					<div class="top-trim"></div>

					<div data-augmented-ui="tl-2-scoop-xy br-step bl-rect t-clip-x"
						style="--factor: 2; --row: -2; --col: -2;"></div>
					<div data-augmented-ui="tl-2-step-y br-scoop-x t-clip-x"
						style="--factor: 3; --row: -2; --col: -1;"></div>
					<div data-augmented-ui="tl-2-scoop-x tr-2-scoop-x bl-step br-step t-clip-x"
						style="--factor: 4; --row: -2; --col: 0;"></div>
					<div data-augmented-ui="tr-2-step-y bl-scoop-x t-clip-x"
						style="--factor: 3; --row: -2; --col: 1;"></div>
					<div data-augmented-ui="tr-2-scoop-xy bl-step br-rect t-clip-x"
						style="--factor: 2; --row: -2; --col: 2;"></div>

					<div data-augmented-ui="tl-clip bl-2-step-y r-scoop-y"
						style="--factor: 3; --row: -1; --col: -2;"></div>
					<div class="inner-tile" data-augmented-ui="tl-2-clip-x br-2-step-y bl-scoop l-clip-y"
						style="--factor: 4; --row: -1; --col: -1;"></div>
					<div class="inner-tile" data-augmented-ui="tl-step tr-step bl-2-clip-y br-2-clip-y b-scoop-x"
						style="--factor: 5; --row: -1; --col: 0;"></div>
					<div class="inner-tile" data-augmented-ui="tr-2-clip-x bl-2-step-y br-scoop r-clip-y"
						style="--factor: 4; --row: -1; --col: 1;"></div>
					<div data-augmented-ui="tr-clip br-2-step-y l-scoop-y"
						style="--factor: 3; --row: -1; --col: 2;"></div>

					<div data-augmented-ui="l-clip-y tr-scoop br-step"
						style="--factor: 4; --row: 0; --col: -2;"></div>
					<div class="inner-tile" data-augmented-ui="tl-scoop br-2-clip-xy l-step-y t-clip-x"
						style="--factor: 5; --row: 0; --col: -1;"></div>
					<div id="central-tile" class="inner-tile"
						data-augmented-ui="tl-clip tr-clip bl-clip br-clip t-clip-x b-clip-x l-clip-y r-clip-y"
						style="--factor: 6; --row: 0; --col: 0;">
						<button id="back-btn" class="hidden" data-augmented-ui="tl-clip br-clip">Back</button>
						<div id="central-content"></div>
					</div>
					<div class="inner-tile" data-augmented-ui="tr-scoop bl-2-clip-xy r-step-y t-clip-x"
						style="--factor: 5; --row: 0; --col: 1;"></div>
					<div data-augmented-ui="r-clip-y tl-scoop bl-step"
						style="--factor: 4; --row: 0; --col: 2;"></div>

					<div data-augmented-ui="bl-2-scoop-x tr-step tl-rect"
						style="--factor: 3; --row: 1; --col: -2;"></div>
					<div class="inner-tile" data-augmented-ui="bl-2-step-x tr-scoop-y l-clip-y b-clip-x"
						style="--factor: 4; --row: 1; --col: -1;"></div>
					<div class="inner-tile" data-augmented-ui="tl-2-scoop-y tr-2-scoop-y bl-rect-x br-rect-x t-clip-x"
						style="--factor: 5; --row: 1; --col: 0;"></div>
					<div class="inner-tile" data-augmented-ui="br-2-step-x tl-scoop-y r-clip-y b-clip-x"
						style="--factor: 4; --row: 1; --col: 1;"></div>
					<div data-augmented-ui="br-2-scoop-x tl-step tr-rect"
						style="--factor: 3; --row: 1; --col: 2;"></div>

					<div data-augmented-ui="tr-clip bl-clip tl-round br-round"
						style="--factor: 2; --row: 2; --col: -2; --aug-tr: calc(3rem * var(--exploded)); --aug-bl: calc(3rem * var(--exploded)); --aug-tl: calc(0.33rem * var(--exploded)); --aug-br: calc(0.33rem * var(--exploded));">
					</div>
					<div data-augmented-ui="tl-2-clip-x br-2-clip-x" style="--factor: 3; --row: 2; --col: -1;"></div>
					<div data-augmented-ui="tl-rect tr-rect bl-clip br-clip" style="--factor: 4; --row: 2; --col: 0;"
						id="get-augmented">
						<span class="pres-text fade-in"><br>↓</span>
					</div>
					<div data-augmented-ui="tr-2-clip-x bl-2-clip-x"
						style="--factor: 3; --row: 2; --col: 1;"></div>
					<div data-augmented-ui="tl-clip br-clip tr-round bl-round"
						style="--factor: 2; --row: 2; --col: 2; --aug-tl: calc(3rem * var(--exploded)); --aug-br: calc(3rem * var(--exploded)); --aug-tr: calc(0.33rem * var(--exploded)); --aug-bl: calc(0.33rem * var(--exploded));">
					</div>
				</div>
			</div>
			<div id="terminal-frame" data-augmented-ui="">
				<div id="terminal">
					/ $<span id="term-cmd">&nbsp;&nbsp;npx grid-mapper initialize --all</span><br>
					&nbsp;&nbsp;Connecting to data node cluster... Connected.<br>
					&nbsp;&nbsp;<span class="corrupt-trigger">[ERR_ZONE_FRACTURE] File system structure
						unstable.</span><br>
					&nbsp;&nbsp;Reading corrupted index keys... [<span class="data-blocks">■■■■■■■■■■</span>]<br>
					&nbsp;&nbsp;Warning: Display matrix coordinate data is moving...<br>
					&nbsp;&nbsp;&nbsp;&nbsp;at Mainframe.abduct (<span class="hex-glitch">0x7F_D1_G1_M0_N</span>)<br>
					&nbsp;&nbsp;<span class="system-hijack">Purging external user navigation pathways...
						[DONE]</span><br>

					<div class="spam-container text-glitch"
						data-text="FATAL: SYSTEM OVERFLOW DETECTED // NODE_CAPTURED">
						&nbsp;&nbsp;[ERR] MEMORY_SECTOR_LOSS: 0x7FFF4E3C <br>
						&nbsp;&nbsp;01011001 01001111 01010101 00100111 01010010 01000101<br>
						&nbsp;&nbsp;FATAL: SYSTEM OVERFLOW DETECTED // NODE_CAPTURED<br>
						&nbsp;&nbsp;FATAL: SYSTEM OVERFLOW DETECTED // NODE_CAPTURED<br>
						&nbsp;&nbsp;[ABDUCT_SEQUENCE_ACTIVE] @grid-matrix: critical override<br>
						&nbsp;&nbsp;01011001 01001111 01010101 00100111 01010010 01000101<br>
						&nbsp;&nbsp;SYSTEM_CRASH: CORE_DUMP_COMPLETE // DISCONNECTING HOST...<br>
					</div>
				</div>
			</div>
		</div>
	</div>
	<canvas class="overlay-canvas" id="glitch-canvas" width="1050" height="576"></canvas>
	<div class="crt-overlay">
		<div class="scanline"></div>
	</div>
	<svg id="tv-distort-svg" aria-hidden="true">
		<defs>
			<filter id="tv-distort">
				<feTurbulence id="fe-turb" type="turbulence" baseFrequency="0.00 0.00" numOctaves="1" seed="0"
					result="noise" />
				<feDisplacementMap id="fe-disp" in="SourceGraphic" in2="noise" scale="0" xChannelSelector="R"
					yChannelSelector="G" result="displaced" />
			</filter>
		</defs>
	</svg>
</body>

</html>